import { render, staticRenderFns } from "./puroverchageconfig.vue?vue&type=template&id=e1fabb16&scoped=true&"
import script from "./puroverchageconfig.vue?vue&type=script&lang=js&"
export * from "./puroverchageconfig.vue?vue&type=script&lang=js&"
import style0 from "./puroverchageconfig.vue?vue&type=style&index=0&id=e1fabb16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fabb16",
  null
  
)

export default component.exports